// MF-67 — One-click choice between a few options, as selectable cards (dot + label + short hint).
// Clearer than a dropdown for 2–4 options; used for types, case status and similar small sets.
import { badgeTokens } from './colorTokens'

const ChoiceCards = ({ options = [], value, onChange, minWidth = 130 }) => (
  <div className='flex flex-wrap' style={{ gap: 10 }}>
    {options.map((o) => {
      const selected = value === o.value
      const t = badgeTokens(o.color || '#64748B')
      return (
        <button
          key={o.value}
          type='button'
          aria-pressed={selected}
          onClick={() => onChange(o.value)}
          className='flex flex-col items-start grow'
          style={{
            flexBasis: minWidth,
            gap: 2,
            padding: '10px 14px',
            borderRadius: 10,
            cursor: 'pointer',
            textAlign: 'left',
            background: selected ? t.bg : '#fff',
            border: `1px solid ${selected ? t.dot : 'rgb(226, 232, 240)'}`,
            boxShadow: selected ? `0 0 0 1px ${t.dot}` : 'none'
          }}
        >
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              fontSize: 13,
              fontWeight: 600,
              color: selected ? t.text : 'rgb(30, 41, 59)'
            }}
          >
            <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: t.dot }} />
            {o.label}
          </span>
          {o.hint ? <span style={{ fontSize: 12, color: 'rgb(100, 116, 139)' }}>{o.hint}</span> : null}
        </button>
      )
    })}
  </div>
)

export default ChoiceCards
